import { QuickStatsMessage } from '../../../../types/QuickStatsMessage';
import { formatMoney } from '../../../common/helpers/formatMoney.helper';
import { translate } from '../../../common/helpers/translate.helper';

import { StatsItem } from './StatsItem';

interface PplStatsItemProps {
    stats: QuickStatsMessage;
}

export const PplStatsItem = ({ stats }: PplStatsItemProps) => {
    return (
        <StatsItem
            item={formatMoney({
                value: stats.ppl.value,
                currency: stats.ppl.currency,
                maximumFractionDigits: 3,
            })}
            description={translate('dashboard.quickstats.ppl')}
        />
    );
};
